import React from "react"
import styled from "styled-components"
import { css } from "../styles/GlobalStyles"

import Card from "./Card"

const StyledCard = styled(Card)`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  overflow: hidden;
  margin-top: 10px;
  box-shadow: var(--shadow-elavated);
`

const InfoColumn = styled.div`
  position: relative;
  z-index: 10;
  text-align: left;
  width: 100%;
  margin: 10px;
`

const Name = styled.div`
  font-weight: bold;
  font-size: var(--font-regular);
  line-height: var(--line-regular);
`

const Major = styled.div`
  font-size: var(--font-sub);
  line-height: var(--line-sub);
  margin-top: 3px;
  margin-bottom: 5px;
`

const SubHeader = styled.div`
  color: var(--gray-text);
  font-size: var(--font-sub);
  line-height: var(--line-sub);
  margin-top: 3px;
`

const ImageColumn = styled.div`
  position: absolute;
  right: 0;
  height: 100%;
  width: 40%;

  margin-top: auto;
  margin-bottom: auto;

  @media (max-width: ${css.breakpoints.wide}) {
    width: 35%;
  }
`

const Image = styled.img`
  height: 100%;
  width: 100%;
  object-fit: cover;
  object-position: center center;
`

type Props = {
  institute: string
  imageURL: string
  major: JSX.Element
  subsection1: JSX.Element
  subsection2: JSX.Element
}

const EducationCard = (
  {institute, imageURL, major, subsection1, subsection2}: Props
  ) => {
  return (
    <StyledCard>
      <InfoColumn>
        <Name>
          {institute}
        </Name>

        <Major>
          {major}
        </Major>

        <SubHeader>
          {subsection1}
        </SubHeader>
        
        <SubHeader>
          {subsection2}
        </SubHeader>
      </InfoColumn>

      <ImageColumn>
        <Image src={imageURL} alt={institute} />
      </ImageColumn>
    </StyledCard>
  )
}

export default EducationCard